import React from "react"
import PropTypes from "prop-types"

import { Icon } from "frontend/components/icons"
import styles from "./SocialIcon.module.css"

const SocialIcon = ({ type, onClick, className }) => {
  return (
    <button
      type="button"
      onClick={() => onClick(type)}
      aria-label={type}
      className={`${styles.container} ${styles[type]} ${className}`}
    >
      <Icon name={type} isSelectable={false} />
    </button>
  )
}

SocialIcon.defaultProps = {
  onClick: () => {},
}

SocialIcon.propTypes = {
  type: PropTypes.string,
  onClick: PropTypes.func,
  className: PropTypes.string,
}

export default SocialIcon
